<div class="loading_wrap">
    <div class="loading_wrap_inner">
	    <div>
		    <div class="loader"></div>
	    </div>
    </div>

</div>